<template>
    <div class="text-center">
      <v-dialog persistent v-model="visible" width="600">
        <v-card class="not-margin pt-0 pr-0 pl-0">
          <v-toolbar dark color="primary">
            <div class="text-center">
              <v-icon>mdi-pencil</v-icon>
              {{ edit ? "Editar" : "Cadastrar" }} Disciplina
            </div>
          </v-toolbar>
          <div class="container dialog">
            <v-form ref="form" v-if="visible">
              <v-row class="justify-center mt-7">
                <v-col cols="12">
                  <v-text-field
                    v-model="content.nome"
                    label="Nome da Disciplina*"
                    counter="40"
                    maxlength="40"
                    dense
                    outlined
                    :rules="[(v) => $required(v), (v) => $max(v, 40)]"
                  ></v-text-field>
                  <v-autocomplete
                    v-model="content.tipoDisciplina"
                    label="Tipo da Disciplina*"
                    dense
                    outlined
                    item-value="id"
                    item-text="tipoDisciplina"
                    :items="tipos"
                    :rules="[(v) => $required(v)]"
                    return-object
                  ></v-autocomplete>
                  <v-textarea
                    v-model="content.descricao"
                    label="Descrição"
                    maxlength="500"
                    counter="500"
                    dense
                    outlined
                    rows="6"
                  ></v-textarea>
                  <v-textarea
                    v-model="content.ementa"
                    label="Ementa"
                    maxlength="1000"
                    counter="1000"
                    dense
                    outlined
                    rows="6"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-form>
          </div>
          <sigfoco-buttons
            actionText="Salvar"
            @click="salvar()"
            @cancel="$emit('onClose')"
          ></sigfoco-buttons>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  import { Disciplina } from '~/commons/classes/disciplina';
  import { DialogProps } from '~/commons/classes/dialog-props';
  import ManterDisciplinaService from '~/services/manter-disciplina.service';
  
  export default {
    props: {
      ...new DialogProps(Disciplina),
      tipos: {
        type: Array,
        default: () => []
      }
    },
    mixins: [ManterDisciplinaService],
    methods: {
      salvar() {
        const save = () => {
          return this.$swal({
            text: `Deseja confirmar essa operação?`,
            type: "warning",
            showCancelButton: true,
            confirmButtonText: `Confirmar`,
            cancelButtonText: `Cancelar`,
          }).then(() => {
            const payload = new Disciplina(this.content).format();
            return this.edit
              ? this.$editarDisciplina(this.content.id, payload)
              : this.$cadastrarDisciplina(payload);
          });
        };
  
        if (this.$validarFormulario("Preencha todos os campos obrigatórios!")) {
          save().then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.$emit("onClose");
            this.$emit("onSave");
          });
        }
      }
    },
  }
  </script>